import { EUnitSystem } from 'interfaces/patients.interfaces';
import { IHealthInfo } from '../interfaces/form.interfaces';

export const calculateHealthBMI = (healthInfo: IHealthInfo): number => {
  let bmi = 0;
  let heightInMeters: number;
  let weightInKg: number;

  const { height, weight, unitSystem } = healthInfo || {};

  if (!healthInfo || !height || !weight) {
    return bmi;
  }

  if (unitSystem === EUnitSystem.IMPERIAL) {
    heightInMeters = +height * 0.0254; // Convert inches to meters
  } else {
    heightInMeters = +height / 100; // Convert centimeters to meters
  }

  if (unitSystem === EUnitSystem.IMPERIAL) {
    weightInKg = +weight * 6.35029; // Convert stones to kilograms
  } else {
    weightInKg = +weight;
  }

  bmi = weightInKg / (heightInMeters * heightInMeters);

  return +bmi.toFixed(1);
};

export const convertStoneToLbs = (weight: number, unitSystem = EUnitSystem.IMPERIAL): number => {
  return unitSystem === EUnitSystem.IMPERIAL ? +(weight * 14).toFixed(1) : weight;
};

export const convertLbsToStone = (weight: number, unitSystem = EUnitSystem.IMPERIAL): number => {
  return unitSystem === EUnitSystem.IMPERIAL ? weight * 0.0714286 : weight;
};

export const convertInchesToFeetAndInches = (
  totalInches: number | string,
): { feet: number; inches: number } => {
  const totalInchesNumber = +(totalInches || 0);

  return {
    feet: Math.floor(+(totalInchesNumber || 0) / 12),
    inches: parseFloat((totalInchesNumber % 12).toFixed(1)),
  };
};

export const convertFeetAndInchesToInches = (
  feet?: number | string,
  inches?: number | string,
): number => {
  const feetNumber = +(feet || 0);
  const inchesNumber = +(inches || 0);

  return feetNumber * 12 + inchesNumber;
};

export const convertStonesToKg = (stones: number | string): number => {
  return parseFloat((+(stones || 0) * 6.350293).toFixed(2));
};

export const convertKgToStones = (kg: number | string): number => {
  return parseFloat((+(kg || 0) / 6.350293).toFixed(2));
};

export const convertCmToFeetAndInches = (cm: number | string): { feet: number; inches: number } => {
  const cmNum = +(cm || 0);
  const totalInches = +(cmNum / 2.54).toFixed(1);
  const feet = Math.floor(totalInches / 12);
  const inches = parseFloat((totalInches % 12).toFixed(1));

  return {
    feet,
    inches,
  };
};

export const convertFeetAndInchesToCm = (
  feet: number | string,
  inches: number | string,
): number => {
  const totalInches = +(feet || 0) * 12 + +(inches || 0);

  return parseFloat((totalInches * 2.54).toFixed(1));
};
